import ApiService from "@/services/ApiService";

const REPOSITORY_URL = "cosecha";

const CosechaRepository = {
  crearRendimientoCosecha(
    idFichaAgricola,
    idProductoCultivo,
    fecha,
    tipo,
    cantidad,
    importeTotal,
    comprador
  ) {
    let data = {
      idFichaAgricola,
      idProductoCultivo,
      fecha,
      tipo,
      cantidad,
      importeTotal,
      comprador,
    };
    return ApiService.post(`${REPOSITORY_URL}/crear_rendimiento_cosecha`, data);
  },

  listaRendimientoCosecha(idFichaAgricola) {
    let data = {
      idFichaAgricola,
    };
    return ApiService.get(`${REPOSITORY_URL}/lista_rendimiento_cosecha`, data);
  },

  actualizarRendimientoCosecha(
    idRendimientoCosecha,
    idProductoCultivo,
    fecha,
    tipo,
    cantidad,
    importeTotal,
    comprador
  ) {
    let data = {
      idRendimientoCosecha,
      idProductoCultivo,
      fecha,
      tipo,
      cantidad,
      importeTotal,
      comprador,
    };
    return ApiService.post(
      `${REPOSITORY_URL}/actualizar_rendimiento_cosecha`,
      data
    );
  },

  borrarRendimientoCosecha(idRendimientoCosecha) {
    let data = {
      idRendimientoCosecha,
    };
    return ApiService.post(
      `${REPOSITORY_URL}/borrar_rendimiento_cosecha`,
      data
    );
  },
};

export default CosechaRepository;
